import {
  PRODUCT_IMAGE_SIZE_DESKTOP,
  PRODUCT_IMAGE_SIZE_MEDIUM,
  PRODUCT_IMAGE_SIZE_MOBILE,
  PRODUCT_IMAGE_SIZE_THUMBNAIL,
} from '@/feature/product/services/product.constants'
import type { CloudflarePictureProps } from '../cloudflare-picture/CloudflarePicture.client'
import { CloudflarePicture } from '../cloudflare-picture/CloudflarePicture.client'
import { PlaceholderPicture } from '../picture/Picture.client'

export const CLOUDFLARE_PRODUCT_SIZES = [
  PRODUCT_IMAGE_SIZE_THUMBNAIL,
  PRODUCT_IMAGE_SIZE_MEDIUM,
  PRODUCT_IMAGE_SIZE_MOBILE,
  PRODUCT_IMAGE_SIZE_DESKTOP,
] as const

export type CloudflarePictureProductSizes = (typeof CLOUDFLARE_PRODUCT_SIZES)[number]

export type CloudflarePictureProductProps = StrictOmit<
  CloudflarePictureProps,
  'width' | 'height'
> & {
  width:
    | {
        mobile?: CloudflarePictureProductSizes
        desktop?: CloudflarePictureProductSizes
      }
    | CloudflarePictureProductSizes

  height?:
    | {
        mobile?: CloudflarePictureProductSizes
        desktop?: CloudflarePictureProductSizes
      }
    | CloudflarePictureProductSizes
}

export function CloudflarePictureProduct({
  src,
  alt,
  width,
  height,
  className,
  id,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  ...rest
}: CloudflarePictureProductProps) {
  if (!src) {
    return (
      <PlaceholderPicture
        alt={alt}
        className={className}
        id={id}
        aria-label={ariaLabel}
        data-testid={dataTestId}
      />
    )
  }

  return (
    <CloudflarePicture
      src={src}
      alt={alt}
      className={className}
      width={width}
      height={height}
      id={id}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      {...rest}
    />
  )
}
